import { isBefore, parseISO } from 'date-fns';
import { SuccessfulCheckIn } from '../models/public-token.model';

const savedValueKey = 'ch-public-check-in-value';
const successfulCheckInKey = 'ch-public-check-in-successful';

const getSavedValue = () => localStorage.getItem(savedValueKey);
const saveValue = (value: string) => localStorage.setItem(savedValueKey, value);

const isSuccessCheckIn = (item: unknown): item is SuccessfulCheckIn => {
    if (!item) {
        return false;
    }

    const itemAs = item as SuccessfulCheckIn;

    if (!itemAs.sessionId || typeof itemAs.sessionId !== 'number') {
        return false;
    }

    if (!itemAs.endDate || typeof itemAs.endDate !== 'string') {
        return false;
    }

    return true;
}

const getSuccessfulCheckIns = (): SuccessfulCheckIn[] => {
    const raw = localStorage.getItem(successfulCheckInKey);
    if (!raw) {
        return [];
    }

    try {
        const parsed: unknown = JSON.parse(raw);

        if (!Array.isArray(parsed)) {
            localStorage.removeItem(successfulCheckInKey);
            return [];
        }

        if (parsed.some(x => !isSuccessCheckIn(x))) {
            localStorage.removeItem(successfulCheckInKey);
            return [];
        }

        return parsed as SuccessfulCheckIn[];
    } catch {
        return [];
    }
}

const addSuccessfulCheckIn = (value: SuccessfulCheckIn) => {
    const existing = getSuccessfulCheckIns();
    if (existing.some(x => x.sessionId === value.sessionId)) {
        return;
    }
    existing.push(value);
    localStorage.setItem(successfulCheckInKey, JSON.stringify(existing));
}

const removeSuccessfulCheckIns = () => {
    localStorage.removeItem(successfulCheckInKey);
}

const cleanup = () => {
    const now = new Date();
    const successful = getSuccessfulCheckIns();
    const withoutExpired = successful.filter((x) => {
        const parsedDate = parseISO(x.endDate);
        return isBefore(now, parsedDate);
    });
    if (withoutExpired.length !== successful.length) {
        localStorage.setItem(successfulCheckInKey, JSON.stringify(withoutExpired));
    }
}

export const publicTokenLocal = {
    getSavedValue,
    saveValue,
    addSuccessfulCheckIn,
    getSuccessfulCheckIns,
    removeSuccessfulCheckIns,
    cleanup,
};
